import type {CookieRef} from '#app';

export const useCookiesStore = defineStore('StoreCookies', () => {
    const {$config} = useNuxtApp();
    const $router = useRouter();
    const {initialize, enableAnalytics, disableAnalytics} = useGtag();

    const year = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);

    const cookies = {
        asked: useCookie('cookies_asked', {path: '/', expires: year}),
        video: useCookie('cookies_video', {path: '/', expires: year}),
        analytic: useCookie('cookies_analytic', {path: '/', expires: year}),
    } as Cookies;

    const cookieValues = computed(() => {
        return {
            asked: !!cookies.asked.value,
            video: !!cookies.video.value,
            analytic: !!cookies.analytic.value,
        };
    });

    function initCookies() {
        if (!!cookies.analytic.value) {
            initialize();
        }
    }

    function setCookie(key: keyof Cookies) {
        const cookie = cookies[key];
        const d = new Date();
        cookie.value = String(d.getTime());
        if (key === 'analytic') {
            initialize();
        }
    }

    function removeCookie(key: keyof Cookies) {
        const cookie = cookies[key];
        cookie.value = null;
        if (key === 'analytic') {
            disableAnalytics();
            useCookie('_ga').value = null;
            useCookie('_ga', {path: '/', domain: 'localhost'}).value = null;
            useCookie('_ga', {path: '/', domain: $config.public.gaDomain}).value = null;
            useCookie($config.public.gaCookieId).value = null;
            useCookie($config.public.gaCookieId, {path: '/', domain: 'localhost'}).value = null;
            useCookie($config.public.gaCookieId, {path: '/', domain: $config.public.gaDomain}).value = null;
        }
    }

    function enableCookie(key: keyof Cookies) {
        setCookie(key);
    }

    function toggleCookies(key: keyof Cookies) {
        !!cookies[key].value ? removeCookie(key) : setCookie(key);
    }

    function acceptDefaultCookies() {
        setCookie('analytic');
        setCookie('video');
        setCookie('asked');
    }

    function customiseCookieSettings() {
        setCookie('asked');
        $router
            .push({name: 'cookies'})
            .then(() => {})
            .catch(() => {});
    }

    return {
        cookies: cookieValues,
        initCookies,
        enableCookie,
        toggleCookies,
        acceptDefaultCookies,
        customiseCookieSettings,
    };
});

interface Cookies {
    asked: CookieRef<string | null | undefined>;
    video: CookieRef<string | null | undefined>;
    analytic: CookieRef<string | null | undefined>;
}
